import { createContext, FC, PropsWithChildren, useState } from "react";

interface ISeasonContext {
  seasonId: number;
  updateSeasonId: (id: number) => void;
}

const defaultState: ISeasonContext = {
  seasonId: 0,
  updateSeasonId(id) {},
};

export const SeasonContext = createContext<ISeasonContext>(defaultState);
export const SeasonContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [currentSeasonId, setSeasonId] = useState<number>(0);

  function updateSeasonId(id: number) {
    setSeasonId(id);
  }

  const value: ISeasonContext = {
    seasonId: currentSeasonId,
    updateSeasonId,
  };

  return (
    <SeasonContext.Provider value={value}>{children}</SeasonContext.Provider>
  );
};
